module.exports = __webpack_public_path__ + "img/photo-0143.a3f399c6.jpg";